import axios from 'axios';
import {isLoggedIn, loadToken} from "@/helper/LocalStorageHelper";
import {authService} from "@/services/AuthService.class";

let baseUrl = process.env.VUE_APP_API;

const client = axios.create({
  baseURL: baseUrl,
  timeout: 1000000,
});

const authClient = axios.create({
  baseURL: baseUrl,
  timeout: 1000000,
});

client.interceptors.request.use((config) => {

  if (isLoggedIn()) {
    const token = loadToken();
    config.headers['Authorization'] = `${token.token_type} ${token.access_token}`
  }
  return config;
}, error => Promise.reject(error));

client.interceptors.response.use((response) => {
    return response;
  },
  error => {
    if (error.response.status === 401) {
      if (isLoggedIn()) {
        return authService.doRefresh(loadToken()).then((refreshResponse) => {
          const token = refreshResponse.data;
          error.config.headers.Authorization = `${token.token_type} ${token.access_token}`;
          return axios(error.config);
        });
      }
    } else {
      return Promise.reject(error);
    }
  }
);

/**
 *
 * @type {AxiosInstance}
 */
export const HTTP = client;
/**
 *
 * @type {AxiosInstance}
 */
export const AUTHHTTP = authClient;
